import { render } from "./component-qyrz.vue?vue&type=template&id=b543962c"
import script from "./component-qyrz.vue?vue&type=script&lang=js"
export * from "./component-qyrz.vue?vue&type=script&lang=js"

import "./component-qyrz.vue?vue&type=style&index=0&id=b543962c&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__